const algoliasearch = require("algoliasearch/lite");
let app_id = "DNCKQNDKN7";
let api_key = "551060ccb836e53ffaacbac640906fda";

export const algoliaClient = algoliasearch(app_id, api_key, {});
